export default "__VITE_PUBLIC_ASSET__d16711b1__"